import React, {type ComponentPropsWithoutRef} from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';
import styles from './scrollable-area.component.module.styl';

const classNames = withCssModule(styles);

/**
 * ScrollableArea props
 */
type ScrollableAreaProps = ComponentPropsWithoutRef<'div'>;

export const ScrollableArea = ({
    children,
    className,
    ...rest
}: ScrollableAreaProps) => (
    <div
        {...rest}
        className={classNames('scrollable-area', className)}>
        {children}
    </div>
);

